/*
 *  			'License for ONE AXA SOFTWARE - Inner Source'
 * 					L O A S - I S
 * 
 * The following License aims to be applied between the AXA Companies, according to the following definition:
 * "AXA Companies" means AXA, Société Anonyme with a “AXA Companies ” Board of Directors having its principal offices at 25, avenue Matignon, 75008 Paris, registered on the Commercial Registry of Paris under the number 572 093 920; and (i) any other company controlled by, or controlling AXA, with a company being considered as controlling another: (a) when it holds directly or indirectly a portion of the capital according to it the majority of the voting rights in general meetings of shareholders of this company; (b) when it holds solely the majority of the voting rights in this company by virtue of an agreement concluded with other partners or shareholders and which is not contrary to the interest of the company; (c) when it determines de facto, by voting rights which it holds, the decisions in the general meetings of shareholders of this company; (d) in any event, when it holds, directly or indirectly, a portion of voting rights greater than 40% and when no other partner or shareholder holds directly or indirectly a portion which is greater than its own; (ii) any economic interest group in which AXA and/or one or more other Companies of the AXA Group participates for at least 50% in operating costs; (iii) in the cases where the law applicable to a company limits voting rights or control (such as defined here in above), this company will be deemed to be a company of the AXA Group, if the voting rights in 2 Binding Corporate Rules – AXA Group – version 2013 general shareholders’ meetings or the control held by a Company of the AXA Group reaches the maximum amount fixed by said applicable law; and (iv) all AXA Companies constitute the “AXA Group” (hereafter "One AXA").  (Binding Corporate Rules - AXA Group - version 2019).
 * 
 * Software credits: 
 * 	Creator: AXA GO GETD
 * 	Main contributors: AXA GO GETD
 * 
 * Permission is hereby granted, free of charge, to any person or entity within One AXA obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software within One AXA, including the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * 
 * The above credit notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * Any improvement or modification of the Software shall be made available to the whole One AXA, under the terms of this License.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { formatDateTimeNoSeconds as formatDateTime, isValidDate } from '@utils/format/dates';
import { Menu, Dropdown, Button, Table, Space, Modal, Tooltip } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import { usePaginationWrapper } from '@hooks/usePaginationWrapper';
import { MESSAGES } from '@translations/labels';
import botIcon from '@svg/botIcon.svg';
import botIconRedOutlined from '@svg/botIconRedOutlined.svg';
import deployIconWhite from '@svg/deployIconWhite.svg';
import miniBotBlackOutlined from '@svg/miniBotBlackOutlined.svg';
import releaseLiveBlackOutline from '@svg/releaseLiveBlackOutline.svg';
import { idField } from '@constants';
import { useAgentId } from '@hooks/useAgentId';
import { InfoTooltip } from '@components/commons/tooltip/infoTooltip';
import { useReleaseLoad } from '../../hooks/useReleaseLoad';
import { useReleaseDeploy } from '../../hooks/useReleaseDeploy';
import { useReleaseDeletion } from '../../hooks/useReleaseDeletion';
import { useReleases } from '../../hooks/useReleases';
import getDeployHistory from 'api/deploy-history';
import releaseHistoryFormStyles from './releaseHistoryFormStyles';
import { useCorpusVersionSelection } from 'commons/hooks/useCorpusVersion';
import { AppContext } from 'commons/contexts/AppContext';

const labels = { ...MESSAGES.commons, ...MESSAGES.manageBot.releasesPage };

const RELEASE_MENU_OPTION = {
  EXPORT_RELEASE: 'export-release',
  LOAD_IN_TEST_THE_BOT: 'load-in-test-the-bot',
  DEPLOY_RELEASE: 'deploy-release',
  DEPLOY_HISTORY: 'deploy-history',
  REMOVE_RELEASE: 'remove-release',
};

const ReleaseHistoryForm = () => {
  const { agentId } = useAgentId();
  const { paginationWrapper } = usePaginationWrapper();
  const releasesResult = useReleases();
  const { startDeployRelease } = useReleaseDeploy();
  const { deleteBotRelease } = useReleaseDeletion();
  const { loadRelease } = useReleaseLoad();
  const { getSelectedVersion, selectVersion } = useCorpusVersionSelection();
  const corpusVersion = getSelectedVersion();
  const { isTrainInProgress, disableDeployToLiveBot, setDisableDeployToLiveBot } = useContext(AppContext);

  const botSubscriptions = useSelector(state => state.agents.botSubscriptions);
  let remoteBotUrl;
  if (botSubscriptions && botSubscriptions.length) {
    remoteBotUrl = botSubscriptions[0].botUrl;
  }

  const { releases } = releasesResult;

  function handleMenuClick(releaseId) {
    return e => {
      // message.info('Click on menu item.');
      console.log('click > key: ', e.key, ' releaseId-> ', releaseId);
      switch (e.key) {
        case RELEASE_MENU_OPTION.EXPORT_RELEASE:
          // TODO: generate a zip with flows, cards & corpus in backend and compress
          break;
        case RELEASE_MENU_OPTION.LOAD_IN_TEST_THE_BOT:
          // TODO: send flows & corpus of release to test the bot /load
          break;
        case RELEASE_MENU_OPTION.DEPLOY_HISTORY:
          console.log('deploy history');
          openDeployHistoryModal(releaseId);
          break;
        case RELEASE_MENU_OPTION.REMOVE_RELEASE:
          openConfirmDeleteModal(releaseId);
          break;
      }
    };
  }

  // start deploy modal
  const handleDeploy = release => () => {
    Modal.destroyAll();
    setDisableDeployToLiveBot(true);
    startDeployRelease(release[idField], true);
  };
  const handleLoadInTest = release => () => {
    Modal.destroyAll();
    loadRelease(release[idField]);
    selectVersion();
  };
  const handleCancel = () => {
    Modal.destroyAll();
  };
  const openConfirmDeployModal = release => {
    const modalSettings = {
      icon: false,
    };
    const contentSettings = {
      okText: 'Deploy in the bot',
      wrapClassName: 'deploy-modal',
      onCancel: handleCancel,
      footer: [
        <Button
          key="submit"
          style={{ color: '#ef6461', border: '2px solid #ef6461' }}
          icon={<img src={botIconRedOutlined} height="24px" style={{ marginBottom: '6px', marginRight: '6px' }} />}
          type="secondary"
          disabled={isTrainInProgress}
          onClick={handleLoadInTest(release)}
        >
          {!isTrainInProgress && 'Load in Test Bot'}
          {isTrainInProgress && 'Training the bot, try later'}
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleDeploy(release)}
          icon={<img src={deployIconWhite} height="24px" style={{ marginBottom: '6px', marginRight: '6px' }} />}
        >
          Deploy in Live Bot
        </Button>,
      ],
    };
    Modal.info({
      ...modalSettings,
      content: (
        <Modal
          title={
            <div style={{ display: 'flex' }}>
              <b style={{ margin: '18px' }}>You are going to deploy this release into production</b>
            </div>
          }
          visible
          {...contentSettings}
          id="ericzon-2"
        >
          <p className="release-to-deploy">
            <strong className="uppercase">{release.name}</strong>
          </p>
          <p>
            This means your live content will change to the content of the selected release. Please confirm that action.
          </p>
          <p>
            We suggest you
            <strong> test this release in AXABots before deploying</strong> for your users.
          </p>
        </Modal>
      ),
    });
  };
  // end modal

  // start test the bot modal
  const handleLoadInTester = release => () => {
    Modal.destroyAll();
    loadRelease(release[idField]);
    selectVersion();
  };
  const openConfirmLoadInTesterModal = release => {
    const modalSettings = {
      icon: false,
    };
    const contentSettings = {
      wrapClassName: 'test-modal',
      onCancel: handleCancel,
      width: 600,
      footer: [
        <Button
          key="submit"
          type="secondary"
          style={{ color: '#ef6461', border: '2px solid #ef6461' }}
          icon={<img src={botIconRedOutlined} height="24px" style={{ marginBottom: '6px', marginRight: '6px' }} />}
          onClick={handleLoadInTester(release)}
        >
          Load in Test Bot
        </Button>,
      ],
    };
    Modal.info({
      ...modalSettings,
      content: (
        <Modal
          title={
            <div style={{ display: 'flex' }}>
              <img src={botIcon} style={{ height: '68px' }} />
              <b style={{ margin: '18px' }}>
                You are going to deploy this release in the 'Test the bot' feature in AXA Bots
              </b>
            </div>
          }
          visible
          {...contentSettings}
        >
          <p className="release-to-test">
            <strong className="uppercase">{release.name}</strong>
          </p>
        </Modal>
      ),
    });
  };
  // end modal

  // start confirm delete release modal
  const handleDeleteRelease = releaseId => () => {
    Modal.destroyAll();
    deleteBotRelease(releaseId);
  };
  const openConfirmDeleteModal = releaseId => {
    const release = releases.find(r => r[idField] === releaseId);
    const currentTitle = release.name;
    const modalSettings = {
      icon: false,
    };
    const contentSettings = {
      okText: 'Confirm',
      onOk: handleDeleteRelease(releaseId),
      onCancel: handleCancel,
    };
    Modal.info({
      ...modalSettings,
      content: (
        <Modal title="Are you sure to delete this version?" visible {...contentSettings}>
          <p>
            Version name: <strong>{currentTitle}</strong>
          </p>
        </Modal>
      ),
    });
  };
  // end modal

  // start deploy history modal
  const deployHistoryColumns = [
    {
      title: () => <span className="bold ">Release creation</span>,
      key: 'createdAt',
      dataIndex: 'createdAt',
      fixed: true,
      width: 200,
      render: record => (isValidDate(record) ? formatDateTime(record) : record),
    },
    {
      title: () => <span className="bold ">Status</span>,
      key: 'status',
      dataIndex: 'status',
      fixed: true,
      width: 200,
    },
    {
      title: () => <span className="bold ">Author</span>,
      key: 'author',
      dataIndex: 'author',
      fixed: true,
      width: 200,
    },
    {
      title: () => <span className="bold ">Last update</span>,
      key: 'lastUpdate',
      dataIndex: 'lastUpdate',
      fixed: true,
      width: 200,
      render: record => (isValidDate(record) ? formatDateTime(record) : record),
    },
    {
      title: () => <span className="bold ">Description</span>,
      key: 'description',
      fixed: true,
      width: 200,
      render: record => (record?.errors?.length ? record.errors[0].message : ''),
    },
  ];
  const openDeployHistoryModal = releaseId => {
    const modalSettings = {
      icon: false,
    };
    const contentSettings = {
      footer: null,
      onCancel: handleCancel,
      width: 800,
    };
    getDeployHistory(agentId, releaseId).then(history => {
      Modal.info({
        ...modalSettings,
        content: (
          <Modal
            title={
              <div style={{ display: 'flex' }}>
                <b style={{ marginTop: '18px' }}>Deploy History</b>
              </div>
            }
            visible
            {...contentSettings}
          >
            <Table
              columns={deployHistoryColumns}
              dataSource={history}
              loading={!history}
              rowKey="_id"
              pagination={false}
            />
          </Modal>
        ),
      });
    });
  };
  // end modal

  const releaseMenu = (releaseId, release) => (
    <Menu className="release-menu" onClick={handleMenuClick(releaseId)}>
      {/**
      <Menu.Item key={RELEASE_MENU_OPTION.EXPORT_RELEASE}>Export release</Menu.Item>
       */}
      {
        <Menu.Item key={RELEASE_MENU_OPTION.DEPLOY_HISTORY} disabled={!release.lastDeploy}>
          View deploy history
        </Menu.Item>
      }

      {
        <Menu.Item
          key={RELEASE_MENU_OPTION.REMOVE_RELEASE}
          disabled={release.isCurrentRelease || release.isBeingTested}
        >
          Remove release
        </Menu.Item>
      }
    </Menu>
  );

  const deployThisRelease = release => () => {
    console.log('startDeployRelease', release);
    openConfirmDeployModal(release);
  };
  const testThisRelease = release => () => {
    openConfirmLoadInTesterModal(release);
  };

  const defaultIconStyles = {
    width: '30px',
    height: '30px',
    minWidth: '30px',
    minHeight: '30px',
    marginRight: '15px',
  };

  const formatDeployStatus = ({ status, errors }) => {
    let icon;
    switch (status) {
      case 'Deployed':
        icon = <CheckCircleOutlined />;
        break;
      case 'Deploy Failed':
        icon = (
          <>
            <CloseCircleOutlined /> {errors?.length && <InfoTooltip label={`${errors[0].message}`} />}
          </>
        );
        break;
      case 'Deploying':
        icon = <LoadingOutlined />;
        break;
      default:
        console.error('formatDeployStatus -> ', status);
        break;
    }
    return icon;
  };

  // Use constants once we have config accessible in whole app
  const getReleaseStatusStyle = lastDeploy => {
    let style = 'release-usage';
    const status = lastDeploy?.status;
    switch (status) {
      case 'Deployed':
        style = 'deploy-success';
        break;
      case 'Deploy Failed':
        style = 'deploy-failed';
        break;
      case 'Deploying':
        style = 'deploy-wip';
        break;
      default:
        console.error('getReleaseStatusStyle -> ', status);
        break;
    }
    return style;
  };

  const columns = [
    {
      title: () => <span className="bold ">Release name</span>,
      key: 'name',
      fixed: true,
      width: 240,
      render: record => {
        return (
          releases &&
          releases.length && (
            <>
              <div>
                <span>{record.name}</span>
              </div>
              {record.isCurrentRelease ? (
                <div>
                  <span className={getReleaseStatusStyle(record?.lastDeploy)}>
                    {record?.lastDeploy?.status === 'Deploying' ? 'Deploying release' : 'Live release'}
                  </span>
                  {record?.lastDeploy && (
                    <span style={{ display: 'inline-flex', alignItems: 'center', marginLeft: '10px' }}>
                      {formatDeployStatus(record.lastDeploy)}
                    </span>
                  )}
                </div>
              ) : (
                <div>
                  {record?.lastDeploy && (
                    <span className="deploy-old">Last deploy: {formatDeployStatus(record.lastDeploy)}</span>
                  )}
                </div>
              )}
              {record.isBeingTested && (
                <div>
                  <span className={getReleaseStatusStyle(record?.lastDeploy)}>Loaded in Test Bot</span>
                </div>
              )}
            </>
          )
        );
      },
    },
    {
      title: () => <span className="bold ">Release creation</span>,
      key: 'releaseCreationDate',
      dataIndex: 'releaseCreationDate',
      fixed: true,
      width: 170,
      render: record => (isValidDate(record) ? formatDateTime(record) : record),
    },
    {
      title: () => <span className="bold ">Author</span>,
      key: 'author',
      dataIndex: ['authorEmail'],
      align: 'left',
      fixed: true,
      width: 150,
      render: (value, record) =>
        record && (
          <>
            {record.authorName && `${record.authorName.substring(0, 13)}...`}
            {!record.authorName && record.authorEmail && `${record.authorEmail.substring(0, 8)}...`}
            {record.authorEmail && <InfoTooltip label={`${record.authorEmail}`} />}
          </>
        ),
    },
    {
      title: () => <span className="bold ">Corpus version</span>,
      key: 'corpusVersion',
      dataIndex: 'corpusVersion',
      align: 'left',
      fixed: true,
      width: 220,
    },

    {
      title: () => <span className="bold ">Corpus creation</span>,
      key: 'corpusCreationDate',
      dataIndex: 'corpusCreationDate',
      align: 'left',
      fixed: true,
      width: 170,
      render: record => (isValidDate(record) ? formatDateTime(record) : record),
    },
    {
      title: () => <span className="bold ">Flow version</span>,
      key: 'flowVersion',
      dataIndex: 'flowVersion',
      align: 'left',
      fixed: true,
      width: 230,
      render: record => {
        return <div>{record}</div>;
      },
    },
    {
      title: () => <span className="bold ">Flow creation</span>,
      key: 'flowCreationDate',
      dataIndex: 'flowCreationDate',
      align: 'left',
      fixed: true,
      width: 170,
      render: record => (isValidDate(record) ? formatDateTime(record) : record),
    },
    {
      title: () => <span className="bold ">VDN version</span>,
      key: 'vdnVersion',
      dataIndex: 'vdnVersion',
      align: 'left',
      fixed: true,
      width: 220,
      render: record => record || '',
    },
    {
      title: () => <span className="bold ">VDN creation</span>,
      key: 'vdnCreationDate',
      dataIndex: 'vdnCreationDate',
      align: 'left',
      fixed: true,
      width: 170,
      render: record => (record && isValidDate(record) ? formatDateTime(record) : ''),
    },
    {
      title: () => <span className="bold ">Last deploy</span>,
      key: 'lastDeployDate',
      dataIndex: 'lastDeploy',
      align: 'left',
      fixed: true,
      width: 170,
      render: record => (record ? formatDateTime(record.createdAt) : ''),
    },
    {
      title: '',
      key: 'action',
      fixed: true,
      width: 200,
      render: record => {
        return releases.length > 0 ? (
          <>
            <Space size="small">
              <div className="buttons-zone">
                {
                  <Tooltip placement="topRight" title="Load in Test Bot!">
                    <Button
                      type="ghost"
                      disabled={record.isBeingTested || isTrainInProgress}
                      icon={<img src={miniBotBlackOutlined} />}
                      onClick={testThisRelease(record)}
                    />
                  </Tooltip>
                }
                {
                  <Tooltip placement="topRight" title="Deploy in Live Bot">
                    <Button
                      type="ghost"
                      disabled={record?.lastDeploy?.status === 'Deploying' || disableDeployToLiveBot}
                      icon={<img src={releaseLiveBlackOutline} />}
                      onClick={deployThisRelease(record)}
                    />
                  </Tooltip>
                }
              </div>
              {
                <Dropdown.Button
                  className="release-menu-dropdown-button"
                  disabled={record.isBeingTested && !record.isCurrentRelease}
                  overlay={releaseMenu(record[idField], record)}
                />
              }
            </Space>
          </>
        ) : null;
      },
    },
  ];

  return (
    <>
      <h4 className="uppercase title-section-contentCorpus">{labels.listOfAvailableReleases}</h4>

      {remoteBotUrl && (
        <a href={remoteBotUrl} target="_blank" rel="noopener noreferrer">
          {labels.btnGoToLiveRelease}
        </a>
      )}
      <Table columns={columns} dataSource={releases} rowKey="_id" pagination={paginationWrapper} />
      <style jsx>{releaseHistoryFormStyles}</style>
    </>
  );
};

export { ReleaseHistoryForm };
